<template>
    <footer class="animate">
        <div class="footer-container">
            <div class="footer-row">
                <img src="../../assets/svg/logo-white.svg" width="300" />
                <p>Ademass Comunicación y Marketing S.L.</p>
                <p>C. Ramos Carrión, 39</p> 
                <p>29016 Málaga</p>
            </div>
            <div class="footer-row" style="margin-bottom: 30px;">
                <h3>Legal</h3>
                <a href="https://ademass.com/privacidad.pdf" target="_blank" class="link">Política de privacidad</a>
                <a href="https://ademass.com/datos.pdf" target="_blank" class="link">Términos de uso</a>
                <a href="https://ademass.com/legal.pdf" target="_blank" class="link">Aviso legal</a>
                <a href="https://ademass.com/cookies.pdf" target="_blank" class="link">Política de cookies</a>
            </div>
            <div class="footer-row">
                <div class="spacer" />
                <h3>Contacto</h3>
                <a href="mailto:info@ademass.com" target="_blank" class="link">info@ademass.com</a>
                <a href="mailto:soporte@ademass.com" target="_blank" class="link">soporte@ademass.com</a>
                <a href="mailto:contrataciones@ademass.com" target="_blank" class="link">contrataciones@ademass.com</a>
                <a href="mailto:negocio@ademass.com" target="_blank" class="link">negocio@ademass.com</a>
                <a href="mailto:administracion@ademass.com" target="_blank" class="link">administracion@ademass.com</a>
            </div>
        </div>
        <p class="advice">Ademass &copy; Todos los derechos reservados.</p>
    </footer>
</template>

<script lang="ts" setup>

</script>

<style scoped>
h3{
    font-size: 24px;
    font-style: Medium;
    font-family: Darker Grotesque;
    font-weight: 700;
}
.link {
    text-decoration: none;
    padding: 5px;
    color: white !important;
    font-size: 20px;
    font-style: Medium;
    font-family: Darker Grotesque;
    font-weight: 500;
    line-height: 94.9999988079071%;
}
.link:hover {
    color: #c2cd27;
}
.logo {
    margin-top: 10px;
}

footer {
    margin-top: 40px;
    padding: 25px;
    overflow-x: hidden;
    background-color: #333333;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white !important;
   
}
.footer-row {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white !important;
}

.footer-row p {
    color: white !important;
    font-size: 20px;
    font-style: Medium;
    font-family: Darker Grotesque;
    font-weight: 500;
    line-height: 94.9999988079071%;
}

.footer-container {
    width: 100%;
    display: flex;
    justify-content: space-around;
    color: white !important;
    overflow-x: hidden;
}

.advice {
    color: white;
    margin-top: 20px;
    text-align: center;
    font-size: 20px;
    font-style: Medium;
    font-family: Darker Grotesque;
    font-weight: 500;
    line-height: 94.9999988079071%;
}

@media(max-width:950px) {
    .footer-container {
        flex-direction: column;
        flex-wrap: wrap;
    }
}
</style>